// Harvard 33-digit charge string, split the same way billing splits it (ReportHelper::getNonInvoicedData).
export const SEGMENTS = [
  { key: 'tub', label: 'Tub', length: 3 },
  { key: 'org', label: 'Org', length: 5 },
  { key: 'object', label: 'Object', length: 4 },
  { key: 'fund', label: 'Fund', length: 6 },
  { key: 'activity', label: 'Activity', length: 6 },
  { key: 'subactivity', label: 'Sub-activity', length: 4 },
  { key: 'root', label: 'Root', length: 5 },
];

export const TOTAL_LENGTH = SEGMENTS.reduce((total, segment) => total + segment.length, 0);

export function splitChargeString(value) {
  const digits = String(value || '').replace(/\D/g, '');
  let offset = 0;
  return SEGMENTS.map((segment) => {
    const part = digits.slice(offset, offset + segment.length);
    offset += segment.length;
    return part;
  });
}

// Stored charge strings are exactly 33 digits; anything else breaks billing's Tub/Org/... split.
export function isValidChargeString(value) {
  return /^\d{33}$/.test(String(value || ''));
}

// Internal project whose charge string is filled in but not a valid 33-digit code.
export function hasInvalidChargeString(project) {
  return !!project && project.type == 'internal' && !!String(project.digCode || '').trim() && !isValidChargeString(project.digCode);
}

// A charge string with more digits than the sections hold: { digits, dropped }, or null when it fits.
// Anything that splits it into sections loses `dropped` without a word, so callers show it.
export function chargeStringOverflow(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length <= TOTAL_LENGTH) return null;
  return { digits, dropped: digits.slice(TOTAL_LENGTH) };
}

export function formatChargeString(value) {
  if (!isValidChargeString(value)) return String(value || '');
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  return splitChargeString(digits).filter(Boolean).join('-');
}
